export var LIKE_ANNOTATION = 'like';